import CurrencyRateComponent from "../../../../components/partner/Settings/currency-rate/currency-rate";

export default function CurrencyRate() {
    return <CurrencyRateComponent />;
  }
  